import { FormEditTabType, FormSettingsTabType, getWebPath } from '@doss/common-all'
import { Link, useNavigate, useSearchParams } from 'react-router'
import { cn } from '~/@/lib/utils'
import { BreadcrumbObjectType } from '~/common/generated/apollo-operations'
import { useDossSignals } from '~/common/hooks/useDossSignals'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'

export function FormNavMenu({ formId }: { formId: string }) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { handleClosePanel } = useDossSignals()
  const { t } = useTypedTranslation()
  const currentTab = searchParams.get('tab') as FormEditTabType | undefined

  const formContentUrl = getWebPath({
    objectType: BreadcrumbObjectType.FORM,
    objectId: formId,
    settings: true,
    settingsParams: {
      tab: FormEditTabType.FORM_CONTENT,
    },
  })

  const formSettingsUrl = getWebPath({
    objectType: BreadcrumbObjectType.FORM,
    objectId: formId,
    settings: true,
    settingsParams: {
      tab: FormEditTabType.SETTINGS,
      settingsTab: FormSettingsTabType.DETAILS,
    },
  })

  return (
    <div className="transition-color flex cursor-pointer items-center justify-center gap-4 px-5 text-sm text-gray-9 duration-300">
      <Link
        className={cn(
          'flex items-center h-full border-b-2 px-2',
          currentTab === FormEditTabType.FORM_CONTENT || !currentTab
            ? 'border-gray-12 text-gray-12'
            : 'border-transparent hover:text-gray-11',
        )}
        onClick={async (e) => {
          e.preventDefault()
          const shouldContinue = await handleClosePanel()
          if (shouldContinue) {
            navigate(formContentUrl)
          }
        }}
        to={formContentUrl}
      >
        {t('form.nav.menu.form_content')}
      </Link>
      <Link
        className={cn(
          'flex items-center h-full border-b-2 px-2',
          currentTab === FormEditTabType.SETTINGS
            ? 'border-gray-12 text-gray-12'
            : 'border-transparent hover:text-gray-11',
        )}
        onClick={async (e) => {
          e.preventDefault()
          const shouldContinue = await handleClosePanel()
          if (shouldContinue) {
            navigate(formSettingsUrl)
          }
        }}
        to={formSettingsUrl}
      >
        {t('form.nav.menu.settings')}
      </Link>
    </div>
  )
}
